/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
import RouterIcon from '@mui/icons-material/Router';
import DevicesIcon from '@mui/icons-material/Devices';
import StorageIcon from '@mui/icons-material/Storage';
import TapAndPlayIcon from '@mui/icons-material/TapAndPlay';
import NodesModal from '../../dashboard/table/nodesModal';
import { getNodesPerCategory } from '../../../store/fuse/monitoreo';
import utils from '../utils';
import { WrapperDevice } from './styles';

const { COLOR_MAP } = utils;

const Index = (props) => {
  const { monitoreo } = props;
  const dispatch = useDispatch();
  const devicesData = monitoreo.filter((deviceData) => deviceData.criticidadId === '2');

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const loadingNodes = useSelector((state) => state.fuse?.monitoreo?.loadingNodes);
  const nodesData = useSelector((state) => state?.fuse?.monitoreo?.nodes);
  const filtersSelected = useSelector((state) => state?.fuse?.monitoreo?.filtersSelected);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const handleDeviceClick = (data, color, criticidadId) => {
    dispatch(getNodesPerCategory('device', data.tipodispositivoid, color, filtersSelected, criticidadId));
    setOpen(true);
  };

  const DeviceIcon = (device) => {
    if (!device) return <DevicesIcon fontSize="large" />;
    if (device === 'Router') {
      return <RouterIcon fontSize="large" sx={{ color: '#000000' }}  />;
    }
    if (device.includes('Switch')) {
      return <img className="device-icon" src="assets/icons/core-switch.png" alt="switch-icon" />;
    }
    if (device === 'Servidor') {
      return <StorageIcon fontSize="large" />;
    }
    if (device === 'Wlc') {
      return <TapAndPlayIcon fontSize="large" sx={{ color: '#000000' }}  />;
    }
    if (device === 'Interiores') {
      return <DevicesIcon fontSize="large" sx={{ color: '#000000' }} />;
    }
    return <StayCurrentLandscapeIcon fontSize="large" sx={{ color: '#000000' }}  />;
  };

  const displayCriticidad = {
    1: 'Criticidad Alta',
    2: 'Criticidad Baja',
  };

  return (
    <WrapperDevice itemGridLength={devicesData.length}>
      <div
        className="flex-col justify-around m-10 rounded-lg mt-0 w-full lg:ml-20 lg:pl-20"
        style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
      >
        <div className="text-metric">
          <h2>Dispositivos Criticidad Baja</h2>
          <h4>Total de Dispositivos</h4>
        </div>
        <div className="flex flex-col section-grid lg:ml-20 lg:pl-20">
          {devicesData.map((data, index) => {
            if (!data.dstipodispositivo) return null;
            return (
            <div className="section-point" key={index}>
              <div className="section-device" key={index}>
                <div className="section-icon">{DeviceIcon(data.dstipodispositivo)}</div>
                <strong>{data.dstipodispositivo}</strong>
              </div>
              <div className="section-percentage">
                {data.verde !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.verde !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.verde, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'verde', data.criticidadId);
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'verde', data.criticidadId);
                        }}
                      />
                    </div>
                    {data.verde}
                  </div>
                )}
                {data.amarillo !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.amarillo !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.amarillo, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'amarillo', data.criticidadId);
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'amarillo', data.criticidadId);
                        }}
                      />
                    </div>
                    {data.amarillo}
                  </div>
                )}
                {data.rojo !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.rojo !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.rojo, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'rojo', data.criticidadId);
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'rojo', data.criticidadId);
                        }}
                      />
                    </div>
                    {data.rojo}
                  </div>
                )}
              </div>
            </div>
          )})}
        </div>
      </div>
      <NodesModal openModal={open} handleCloseModal={handleClose} loading={loadingNodes} nodesData={nodesData} redirectPath="/monitoreo" />
    </WrapperDevice>
  );
};

export default Index;
